import { update } from "lodash";

// Permission Actions /
export const authAPIUrls = {
  login: "/login",
  logout: "/logout",
  sendOtp: "/request-reset-otp",
  submitOtp: "/verify-otp",
  changePassword: "/reset-password",
  userPermissions: "/user/permissions",
};

// Permission Actions //
export const permissionAPIUrls = {
  get: "/permissions/get",
  create: "/permissions/create",
  update: "/permissions/update",
};

// Role Actions //
export const roleAPIUrls = {
  get: "/roles/get",
  create: "/roles/create",
  update: "/roles/update",
};

// Location Actions //
export const locationAPIUrls = {
  get: "/locations/get",
  create: "/locations/create",
  update: "/locations/update",
  getAssignLocation:"/locations/user-locations"
};

// Notification Actions //
export const notificationAPIUrls = {
  get: "/notifications/get",
  create: "/notifications/create",
  update: "/notifications/update",
};

// User Actions //
export const userAPIUrls = {
  get: "/users/get",
  getAll: "/users/get-all",
  getUsers: "/users/get-all-users",
  getAgents: "/users/getAgents",
  getLocationBaseAgents: "/users/getLocationBaseAgents",
  getAgentManagers: "/users/get_agents_managers_admins",
  create: "/users/create",
  update: "/users/update",
};

// Customer Actions //
export const customerAPIUrls = {
  get: "/customers/get",
  getAll: "/customers/get-all",
  getQueries: "/customers/queries",
  create: "/customers/create",
  update: "/customers/update",
  details: "/customers/customer-details",
  phonenumber: "/customers/PhoneNumbersList",
};
// Query Actions //
export const queryAPIUrls = {
  get: "/queries/get",
  amadeusGet: "/queries/get/amadeus",
  actionable: "/queries/actionable",
  search: "/queries/global",
  getById: "/queries/detail",
  create: "/queries/create",
  update: "/queries/update",
  getActivities: "/queries/get-activity-log",
  createActivity: "/queries/create-activity-log",
  assign: "/queries/assign-to",
  reAssign: "/queries/billingReassign",
  forceClose: "/queries/force-close",
  viewPermission: "/queries/view-permission-action",
  cancellation: "/queries/cancellation-request",
  changeDate: "/queries/change-date-request",
  rescheduledByAirline: "/queries/rescheduled-by-airline-request",
  all: "/queries/get?stage=0",
  callBack: "/callback",
  userQueries: "/queries/customer_queries",
  getQueues: "/queries/queues/list",
  getTicketQueues: "/amadeus/query/queues",
  assignToTicketing: "/queries/assignForTicket",
  updateTicketQueue: "/amadeus/query/queues/view",
  viewAmadeusQueue: "/amadeus/query/queues/view",
  updateQueue: "/queries/assignFromQueue",
  queriesQue: "/queries/queues",
  updateStatus: "/queries/change-query-status",
  coldFlowList: "/queries/cold-flow-queries",
  exportQueries: "/queries-export",
  billingDocs: "/queries/previousBillingDocs",
  getTerms: "/get-terms",
  queryLocation: "/query_location"
};

// Quotation Actions //
export const quotationAPIUrls = {
  create: "/quotations/create",
  accept: "/quotations/mark-accepted",
  send: "/quotations/send",
  uploadTicket: "/quotations/upload-ticket",
  sendTicket: "/quotations/send-ticket",
  deleteTicket: "/quotations/delete-ticket",
  fetchTicket: "/quotations/getQuotationTicket",
};

// Payment Actions //
export const paymentAPIUrls = {
  create: "/payments/create",
  initiateCancellation: "/payments/initiate-cancellation",
  initiateRefund: "/payments/initiate-refund",
  completeRefund: "/payments/complete-refund",
  accept: "/payments/mark-completed",
  getById: "/payments/get",
  getSignTemplates: "/payments/templates",
};

// Passenger Actions //
export const passengerAPIUrls = {
  get: "/passengers/get",
  create: "/passengers/create",
  update: "/passengers/update",
};

// Dashbooard Actions //
export const dashboardAPIUrls = {
  get: "/dashboard",
  globalSearch: "/global-search/search",
};

// Email Template Actions //
export const emailTemplateAPIUrls = {
  get: "/templates/get",
  create: "/templates/create",
  update: "/templates/update",
  delete: "/templates/delete",
};

// Messages Actions
export const messagesAPIUrls = {
  get: "/messages/get",
  create: "/messages/send-message",
  update: "/messages/update",
};

// Chat
export const chatAPIUrls = {
  getCustomer: "/chat/query-by-search",
  resolveThread: "/thread/resolve",
  assignThread: "/chat/chatAssignment",
  getChatHistory: "/chat/query-history",
  updateChat: "/chat/RenameUser",
  createChatRoom: "/create-chat-room",
  getChatRooms: "/group-chat",
  getChatUsers: "/chat-users",
  sendChatMessage: "/send-message",
  updateGroup: "/update-group",
  ongoingChat: "/ongoing-chat",
  pubNubToken: "/pubnub-auth-token",
  readChat: "/read-chat"
};

// Reminder Actions
export const reminderAPIUrls = {
  get: "/reminders",
  getById: (id: string) => `/reminders/${id}`,
  getActivityLogs: (id: string) => `/reminders/${id}/activity-logs`,
  create: "/reminders",
  update: (id: string) => `/reminders/${id}`,
  delete: (id: string) => `/reminders/${id}`,
  remindersExport: "reminders/export",
  completeReminder: `reminders/complete`,
  deleteReminder: `reminders/delete`,
  detailReminder: `reminders/detail`,
  updateReminder: `reminders/update`,
  reminderQueue: `reminders/queue`,
  assignReminderMultiple: `assign-multiple`,
};

export const callAPIUrls = {
  getAllUsers: "all-users",
  getExportCallLogs: "export-call-logs",
  getCallLogsAnalytics: "call-logs-analytics",
};

export const callDocUserAPIUrls = {
  getCallUsersDoc: "call-doc-users",
  getCallAdminDoc: "call-doc-admins",
};
